import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {AlterarStatusAgendamento} from "../../models/alterar-status-agendamento";
import {AtendimentoService} from "../../../modules/cadastro/services/atendimento.service";

@Component({
  selector: 'app-alterar-status-agendamento',
  standalone: false,
  templateUrl: './alterar-status-agendamento.component.html',
  styleUrl: './alterar-status-agendamento.component.css'
})
export class AlterarStatusAgendamentoComponent {
  @Input() showModal = false;
  @Input() atendimentoId: number;
  @Input() statusDestino = 0;
  @Input() nomeStatusDestino = '';
  @Output() fecharModalPai = new EventEmitter<void>();

  alterarStatusAgendamento = new AlterarStatusAgendamento();
  formAlterar: FormGroup;

  constructor(
    private atendimentoService: AtendimentoService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {
    this.construirFormulario();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['atendimentoId'] || changes['statusDestino']) && this.showModal) {
      this.alterarStatusAgendamento.id = this.atendimentoId;
      this.formAlterar.controls['id'].setValue(this.atendimentoId);

      this.formAlterar.get('status')?.setValue(this.statusDestino);
      this.alterarStatusAgendamento.status = this.statusDestino;
    }
  }

  salvar() {
    this.validarFormulario();
    if (this.formAlterar.invalid) {
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.preencherModelo();
       this.atendimentoService.alterarStatus(this.alterarStatusAgendamento).subscribe(resultado =>{
         if(resultado.sucesso){
           this.toastr.success("Status alterado com sucesso");
           this.fecharModal();
         }else{
           this.toastr.error("Erro ao alterar status - " + resultado.errors[0].mensagem);
         }
       }, error => {
         if(error.status === 500){
           this.toastr.error(error.error);
         }
         else{
           this.toastr.error("Erro ao alterar status");
         }
       });
      }
    });
  }

  fecharModal() {
    this.formAlterar.reset();
    this.showModal = false;
    this.fecharModalPai.emit();
  }

  onBackgroundClick(event: Event): void {
    this.fecharModal();
  }

  private validarFormulario() {
    Object.keys(this.formAlterar.controls).forEach(name => {
      const control = this.formAlterar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private preencherModelo() {
    this.alterarStatusAgendamento.id = this.formAlterar.controls['id'].value;
    this.alterarStatusAgendamento.nota = this.formAlterar.controls['nota'].value;
    this.alterarStatusAgendamento.encerrarTarefas = this.formAlterar.controls['tarefasEncerrar'].value;
  }

  private construirFormulario() {
    this.formAlterar = this.formBuilder.group({
      id: [this.alterarStatusAgendamento.id],
      status: [{value: this.alterarStatusAgendamento.status, disabled: true}, [Validators.required]],
      nota: [this.alterarStatusAgendamento.nota, [Validators.required]],
      tarefasEncerrar: [this.alterarStatusAgendamento.encerrarTarefas]
    });
  }
}
